(function () {
  var PARAM_AVAILABILITY = 'custom_availability';
  var PARAM_PAGE = 'custom_availability_page';
  var VALID_MODES = ['all', 'in-stock', 'out-of-stock'];
  var PRODUCT_PAGE_SIZE = 250;
  var FETCH_BATCH_SIZE = 4;

  function init() {
    var roots = document.querySelectorAll('[data-custom-availability-root]');

    roots.forEach(function (root) {
      if (root.dataset.customAvailabilityEnabled !== 'true' || root.dataset.customAvailabilityInitialized === 'true') {
        return;
      }

      root.dataset.customAvailabilityInitialized = 'true';
      setupRoot(root);
    });
  }

  function setupRoot(root) {
    var grid = root.querySelector('[data-productgrid-items]');
    var summary = root.querySelector('[data-custom-availability-summary]');
    var pagination = root.querySelector('[data-custom-availability-pagination-wrapper]');
    var controls = document.querySelectorAll('[data-custom-availability-link]');

    if (!grid || !summary || !pagination || !controls.length) {
      return;
    }

    var initialUrl = new URL(window.location.href);
    var collectionUrl = (root.dataset.customAvailabilityCollectionUrl || window.location.pathname).replace(/\/$/, '');
    var imageStyle = root.dataset.customAvailabilityImageStyle || 'natural';
    var imageCrop = root.dataset.customAvailabilityImageCrop === 'true';

    var state = {
      root: root,
      grid: grid,
      summary: summary,
      pagination: pagination,
      collectionUrl: collectionUrl,
      defaultPage: initialUrl.searchParams.get('page'),
      totalCount: parseInteger(root.dataset.customAvailabilityProductCount, 0),
      pageSize: parseInteger(root.dataset.customAvailabilityProductsPerPage, 24),
      moneyFormat: root.dataset.customAvailabilityMoneyFormat || '${{amount}}',
      imageClass: getImageClass(imageStyle, imageCrop),
      originalGridHolder: document.createElement('div'),
      originalPaginationHolder: document.createElement('div'),
      originalDetached: false,
      counts: {
        all: parseInteger(root.dataset.customAvailabilityProductCount, 0),
        'in-stock': null,
        'out-of-stock': null
      },
      products: null,
      loadPromise: null,
      renderToken: 0
    };

    updateControls(state, getModeFromUrl(), false);

    document.addEventListener('click', function (event) {
      var control = event.target.closest('[data-custom-availability-link]');
      if (control) {
        var selectedMode = normalizeMode(control.dataset.customAvailabilityLink);

        if (!selectedMode) {
          return;
        }

        event.preventDefault();
        pushUrl(state, selectedMode, 1);
        renderState(state, {
          scroll: true
        });
        return;
      }

      var pageLink = event.target.closest('[data-custom-availability-page-link]');
      if (!pageLink) {
        return;
      }

      event.preventDefault();
      var requestedPage = parseInteger(pageLink.dataset.customAvailabilityPageLink, 1);
      pushUrl(state, getModeFromUrl(), requestedPage);
      renderState(state, {
        scroll: true
      });
    });

    window.addEventListener('popstate', function () {
      renderState(state, {
        scroll: false
      });
    });

    warmCache(state);

    renderState(state, {
      scroll: false
    });
  }

  async function renderState(state, options) {
    var mode = getModeFromUrl();
    var page = getPageFromUrl();
    var token = ++state.renderToken;
    var itemsNeeded = page * state.pageSize;
    var hasRenderedPreview = false;

    updateControls(state, mode, false);

    if (mode === 'all') {
      restoreDefaultView(state);

      if (options && options.scroll) {
        scrollToResults(state);
      }

      return;
    }

    renderLoadingState(state, mode);

    try {
      var products = await loadProducts(state, {
        onProgress: function (allProducts, isComplete) {
          if (isComplete || hasRenderedPreview || token !== state.renderToken) {
            return;
          }

          var filteredProducts = filterProductsByMode(allProducts, mode);

          if (!filteredProducts.length) {
            return;
          }

          if (filteredProducts.length < itemsNeeded) {
            return;
          }

          hasRenderedPreview = true;
          renderFilteredResults(state, filteredProducts, mode, page, null, {
            isPreview: true
          });
        }
      });

      if (token !== state.renderToken) {
        return;
      }

      var filteredProducts = filterProductsByMode(products, mode);

      var totalPages = Math.max(1, Math.ceil(filteredProducts.length / state.pageSize));
      var currentPage = clamp(page, 1, totalPages);

      if (currentPage !== page) {
        replaceUrl(state, mode, currentPage);
      }

      renderFilteredResults(state, filteredProducts, mode, currentPage, totalPages);

      if (options && options.scroll) {
        scrollToResults(state);
      }
    } catch (error) {
      if (token !== state.renderToken) {
        return;
      }

      renderErrorState(state, mode);
    }
  }

  function restoreDefaultView(state) {
    state.summary.hidden = true;
    state.summary.innerHTML = '';
    restoreOriginalContent(state);
  }

  function renderLoadingState(state, mode) {
    detachOriginalContent(state);
    state.summary.hidden = false;
    state.summary.innerHTML = [
      '<div class="productgrid--filters">',
      '<p class="custom-availability-summary__meta">',
      'Loading ',
      escapeHtml(getModeLabel(mode).toLowerCase()),
      ' products...',
      '</p>',
      '</div>'
    ].join('');

    state.grid.innerHTML = [
      '<div class="productgrid--no-results custom-availability-state">',
      '<h2 class="productgrid--no-results-title">Preparing filtered results...</h2>',
      '</div>'
    ].join('');
    state.pagination.innerHTML = '';
  }

  function renderErrorState(state, mode) {
    detachOriginalContent(state);
    state.summary.hidden = false;
    state.summary.innerHTML = [
      '<div class="productgrid--filters">',
      '<p class="custom-availability-summary__meta">',
      'The custom ',
      escapeHtml(getModeLabel(mode).toLowerCase()),
      ' filter could not be loaded right now.',
      '</p>',
      '<p class="custom-availability-summary__action">',
      '<a href="',
      escapeHtml(buildUrl(state, 'all', 1).toString()),
      '" data-custom-availability-link="all">Show all products</a>',
      '</p>',
      '</div>'
    ].join('');

    state.grid.innerHTML = [
      '<div class="productgrid--no-results custom-availability-state">',
      '<h2 class="productgrid--no-results-title">Unable to load filtered products.</h2>',
      '</div>'
    ].join('');
    state.pagination.innerHTML = '';
  }

  function renderFilteredResults(state, filteredProducts, mode, currentPage, totalPages, options) {
    var renderOptions = options || {};

    detachOriginalContent(state);

    var startIndex = (currentPage - 1) * state.pageSize;
    var visibleProducts = filteredProducts.slice(startIndex, startIndex + state.pageSize);

    state.summary.hidden = false;
    state.summary.innerHTML = renderSummary(
      state,
      filteredProducts.length,
      visibleProducts.length,
      startIndex,
      mode,
      renderOptions.isPreview
    );

    if (!visibleProducts.length) {
      state.grid.innerHTML = [
        '<div class="productgrid--no-results custom-availability-state">',
        '<h2 class="productgrid--no-results-title">No ',
        escapeHtml(getModeLabel(mode).toLowerCase()),
        ' products found.</h2>',
        '</div>'
      ].join('');
      state.pagination.innerHTML = '';
      updateControls(state, mode, true);
      return;
    }

    state.grid.innerHTML = visibleProducts.map(function (product) {
      return renderProductCard(state, product);
    }).join('');

    state.pagination.innerHTML = renderOptions.isPreview ? '' : renderPagination(state, mode, currentPage, totalPages);
    updateControls(state, mode, !renderOptions.isPreview);
  }

  async function loadProducts(state, options) {
    var loadOptions = options || {};

    if (Array.isArray(state.products)) {
      return state.products;
    }

    var cachedProducts = readCache(state);
    if (cachedProducts) {
      state.products = cachedProducts;
      updateCounts(state, cachedProducts);
      if (typeof loadOptions.onProgress === 'function') {
        loadOptions.onProgress(cachedProducts, true);
      }
      return cachedProducts;
    }

    if (state.loadPromise) {
      return state.loadPromise;
    }

    state.loadPromise = fetchAllProducts(state, loadOptions).then(function (products) {
      state.products = products;
      updateCounts(state, products);
      writeCache(state, products);
      return products;
    }).finally(function () {
      state.loadPromise = null;
    });

    return state.loadPromise;
  }

  function warmCache(state) {
    if (Array.isArray(state.products) || state.loadPromise || readCache(state)) {
      return;
    }

    var scheduleWarm = window.requestIdleCallback ? window.requestIdleCallback : function (callback) {
      return window.setTimeout(callback, 1200);
    };

    scheduleWarm(function () {
      if (Array.isArray(state.products) || state.loadPromise || readCache(state)) {
        return;
      }

      loadProducts(state).catch(function () {
        return;
      });
    });
  }

  async function fetchAllProducts(state, options) {
    var fetchOptions = options || {};
    var pageCount = Math.max(1, Math.ceil(state.totalCount / PRODUCT_PAGE_SIZE));
    var products = [];

    for (var startPage = 1; startPage <= pageCount; startPage += FETCH_BATCH_SIZE) {
      var requests = [];
      var endPage = Math.min(startPage + FETCH_BATCH_SIZE - 1, pageCount);

      for (var page = startPage; page <= endPage; page += 1) {
        requests.push(fetchProductsPage(state, page));
      }

      var batchResults = await Promise.all(requests);
      batchResults.forEach(function (pageProducts) {
        products = products.concat(pageProducts);
      });

       if (typeof fetchOptions.onProgress === 'function') {
        fetchOptions.onProgress(products.slice(), false);
      }
    }

    if (typeof fetchOptions.onProgress === 'function') {
      fetchOptions.onProgress(products.slice(), true);
    }

    return products;
  }

  async function fetchProductsPage(state, page) {
    var requestUrl = new URL(state.collectionUrl + '/products.json', window.location.origin);
    var currentUrl = new URL(window.location.href);
    var sortBy = currentUrl.searchParams.get('sort_by');

    requestUrl.searchParams.set('limit', String(PRODUCT_PAGE_SIZE));
    requestUrl.searchParams.set('page', String(page));

    if (sortBy) {
      requestUrl.searchParams.set('sort_by', sortBy);
    }

    var response = await fetch(requestUrl.toString(), {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to load collection products.');
    }

    var payload = await response.json();
    var sourceProducts = payload && Array.isArray(payload.products) ? payload.products : [];

    return sourceProducts.map(function (product) {
      return normalizeProduct(state, product);
    }).filter(Boolean);
  }

  function normalizeProduct(state, product) {
    if (!product || !product.handle) {
      return null;
    }

    var variants = Array.isArray(product.variants) ? product.variants : [];
    var available = variants.some(function (variant) {
      return Boolean(variant.available);
    });
    var priceValues = variants.map(function (variant) {
      return moneyStringToCents(variant.price);
    }).filter(isFiniteNumber);
    var minPrice = priceValues.length ? Math.min.apply(Math, priceValues) : 0;
    var maxPrice = priceValues.length ? Math.max.apply(Math, priceValues) : minPrice;
    var saleVariants = variants.map(function (variant) {
      var price = moneyStringToCents(variant.price);
      var compareAtPrice = moneyStringToCents(variant.compare_at_price);

      if (!isFiniteNumber(compareAtPrice) || compareAtPrice <= price) {
        return null;
      }

      return {
        price: price,
        compareAtPrice: compareAtPrice
      };
    }).filter(Boolean);
    var compareAtValues = saleVariants.map(function (variant) {
      return variant.compareAtPrice;
    });
    var image = Array.isArray(product.images) && product.images.length ? product.images[0] : null;

    return {
      available: available,
      compareAtMax: compareAtValues.length ? Math.max.apply(Math, compareAtValues) : null,
      compareAtMin: compareAtValues.length ? Math.min.apply(Math, compareAtValues) : null,
      imageAspectRatio: image && image.width && image.height ? image.width / image.height : null,
      imageHeight: image && image.height ? image.height : null,
      imageSrc: image && image.src ? withImageWidth(image.src, 720) : '',
      imageWidth: image && image.width ? image.width : null,
      title: product.title || '',
      url: state.collectionUrl + '/products/' + product.handle,
      minPrice: minPrice,
      maxPrice: maxPrice
    };
  }

  function renderSummary(state, resultCount, visibleCount, startIndex, mode, isPreview) {
    var endIndex = startIndex + visibleCount;

    if (!resultCount) {
      return [
        '<div class="productgrid--filters">',
        '<p class="custom-availability-summary__meta">',
        'No ',
        escapeHtml(getModeLabel(mode).toLowerCase()),
        ' products found.',
        '</p>',
        '<p class="custom-availability-summary__action">',
        '<a href="',
        escapeHtml(buildUrl(state, 'all', 1).toString()),
        '" data-custom-availability-link="all">Show all products</a>',
        '</p>',
        '</div>'
      ].join('');
    }

    return [
      '<div class="productgrid--filters">',
      '<p class="custom-availability-summary__meta">',
      'Showing ',
      escapeHtml(formatNumber(startIndex + 1)),
      '-',
      escapeHtml(formatNumber(endIndex)),
      ' of ',
      escapeHtml(formatNumber(resultCount)),
      ' ',
      escapeHtml(getModeLabel(mode).toLowerCase()),
      isPreview ? '+ products while the rest load...' : ' products.',
      '</p>',
      isPreview ? '' : [
        '<p class="custom-availability-summary__action">',
        '<a href="',
        escapeHtml(buildUrl(state, 'all', 1).toString()),
        '" data-custom-availability-link="all">Show all products</a>',
        '</p>'
      ].join(''),
      '</div>'
    ].join('');
  }

  function filterProductsByMode(products, mode) {
    return products.filter(function (product) {
      return mode === 'in-stock' ? product.available : !product.available;
    });
  }

  function renderPagination(state, mode, currentPage, totalPages) {
    if (totalPages <= 1) {
      return '';
    }

    var parts = buildPaginationParts(currentPage, totalPages);
    var html = [
      '<nav class="pagination--container" aria-label="Pagination">',
      '<ul class="pagination--inner">'
    ];

    if (currentPage > 1) {
      html.push(
        '<li class="pagination--previous">',
        '<a class="pagination--item" href="',
        escapeHtml(buildUrl(state, mode, currentPage - 1).toString()),
        '" data-custom-availability-page-link="',
        String(currentPage - 1),
        '" aria-label="Go to previous page">',
        '<span class="pagination--chevron-left" aria-hidden="true">&#8249;</span>',
        'Prev',
        '</a>',
        '</li>'
      );
    }

    parts.forEach(function (part) {
      if (part === 'ellipsis') {
        html.push(
          '<li class="pagination--ellipsis">',
          '<span class="pagination--item">&hellip;</span>',
          '</li>'
        );
        return;
      }

      if (part === currentPage) {
        html.push(
          '<li class="pagination--active" aria-current="true" aria-label="Page ',
          String(part),
          '">',
          '<span class="pagination--item">',
          String(part),
          '</span>',
          '</li>'
        );
        return;
      }

      html.push(
        '<li>',
        '<a class="pagination--item" href="',
        escapeHtml(buildUrl(state, mode, part).toString()),
        '" data-custom-availability-page-link="',
        String(part),
        '" aria-label="Go to page ',
        String(part),
        '">',
        String(part),
        '</a>',
        '</li>'
      );
    });

    if (currentPage < totalPages) {
      html.push(
        '<li class="pagination--next">',
        '<a class="pagination--item" href="',
        escapeHtml(buildUrl(state, mode, currentPage + 1).toString()),
        '" data-custom-availability-page-link="',
        String(currentPage + 1),
        '" aria-label="Go to next page">',
        'Next',
        '<span class="pagination--chevron-right" aria-hidden="true">&#8250;</span>',
        '</a>',
        '</li>'
      );
    }

    html.push('</ul>', '</nav>');

    return html.join('');
  }

  function renderProductCard(state, product) {
    var imageMarkup = renderProductImage(product);
    var priceMarkup = renderPriceMarkup(state, product);
    var statusText = product.available ? 'In stock' : 'Out of stock';
    var stockStatus = product.available ? 'in-stock' : 'out-of-stock';

    return [
      '<div class="productgrid--item ',
      escapeHtml(state.imageClass),
      !product.imageSrc ? ' imagestyle--no-image' : '',
      '">',
      '<div class="productitem custom-availability-product">',
      '<div class="productitem__container">',
      '<div class="productitem__image-container">',
      imageMarkup,
      '</div>',
      '<div class="productitem--info">',
      '<h2 class="productitem--title">',
      '<a href="',
      escapeHtml(product.url),
      '">',
      escapeHtml(product.title),
      '</a>',
      '</h2>',
      priceMarkup,
      '<p class="custom-availability-product__status" data-stock-status="',
      stockStatus,
      '">',
      statusText,
      '</p>',
      '</div>',
      '</div>',
      '</div>',
      '</div>'
    ].join('');
  }

  function renderProductImage(product) {
    if (!product.imageSrc) {
      return [
        '<div class="productitem--image-link" aria-hidden="true">',
        '<figure class="productitem--image">',
        '<div class="custom-availability-product__image-placeholder">No image available</div>',
        '</figure>',
        '</div>'
      ].join('');
    }

    var naturalStyle = product.imageAspectRatio ? ' style="--product-grid-item-image-aspect-ratio: ' + escapeHtml(String(product.imageAspectRatio)) + ';"' : '';
    var widthAttribute = product.imageWidth ? ' width="' + escapeHtml(String(product.imageWidth)) + '"' : '';
    var heightAttribute = product.imageHeight ? ' height="' + escapeHtml(String(product.imageHeight)) + '"' : '';

    return [
      '<a class="productitem--image-link" href="',
      escapeHtml(product.url),
      '" tabindex="-1">',
      '<figure class="productitem--image"',
      naturalStyle,
      '>',
      '<img class="productitem--image-primary" src="',
      escapeHtml(product.imageSrc),
      '" alt="',
      escapeHtml(product.title),
      '" loading="lazy" decoding="async"',
      widthAttribute,
      heightAttribute,
      '>',
      '<span class="visually-hidden">',
      escapeHtml(product.title),
      '</span>',
      '</figure>',
      '</a>'
    ].join('');
  }

  function renderPriceMarkup(state, product) {
    var priceRange = product.minPrice !== product.maxPrice;
    var onSale = isFiniteNumber(product.compareAtMin) && product.compareAtMin > product.minPrice;
    var compareMarkup = '';

    if (onSale) {
      compareMarkup = [
        '<div class="price__compare-at visible">',
        '<span class="money">',
        escapeHtml(formatPriceRange(state, product.compareAtMin, product.compareAtMax)),
        '</span>',
        '</div>'
      ].join('');
    }

    return [
      '<div class="price productitem__price',
      priceRange ? ' price--varies' : '',
      '">',
      compareMarkup,
      '<div class="price__current',
      onSale ? ' price__current--on-sale' : '',
      '">',
      '<span class="money">',
      escapeHtml(formatPriceRange(state, product.minPrice, product.maxPrice)),
      '</span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function updateControls(state, mode, countsReady) {
    document.querySelectorAll('[data-custom-availability-link]').forEach(function (link) {
      var linkMode = normalizeMode(link.dataset.customAvailabilityLink);
      var listItem = link.closest('[data-custom-availability-option]');
      var active = linkMode === mode;

      if (!linkMode) {
        return;
      }

      link.setAttribute('href', buildUrl(state, linkMode, 1).toString());

      if (listItem) {
        listItem.dataset.filterActive = active ? 'true' : 'false';

        if (active) {
          listItem.setAttribute('aria-current', 'true');
        } else {
          listItem.removeAttribute('aria-current');
        }
      }

      setCheckmarkState(link, active);
    });

    if (countsReady || state.counts.all > 0) {
      document.querySelectorAll('[data-custom-availability-count]').forEach(function (countNode) {
        var countKey = countNode.dataset.customAvailabilityCount;
        var countValue = state.counts[countKey];

        countNode.textContent = isFiniteNumber(countValue) ? '(' + formatNumber(countValue) + ')' : '';
      });
    }
  }

  function updateCounts(state, products) {
    var inStockCount = 0;

    products.forEach(function (product) {
      if (product.available) {
        inStockCount += 1;
      }
    });

    state.counts['in-stock'] = inStockCount;
    state.counts['out-of-stock'] = products.length - inStockCount;
    updateControls(state, getModeFromUrl(), true);
  }

  function readCache(state) {
    try {
      var rawValue = window.sessionStorage.getItem(getCacheKey(state));

      if (!rawValue) {
        return null;
      }

      var parsedValue = JSON.parse(rawValue);

      if (!parsedValue || parsedValue.totalCount !== state.totalCount || !Array.isArray(parsedValue.products)) {
        return null;
      }

      return parsedValue.products;
    } catch (error) {
      return null;
    }
  }

  function writeCache(state, products) {
    try {
      window.sessionStorage.setItem(getCacheKey(state), JSON.stringify({
        totalCount: state.totalCount,
        products: products
      }));
    } catch (error) {
      return;
    }
  }

  function getCacheKey(state) {
    var currentUrl = new URL(window.location.href);
    var sortBy = currentUrl.searchParams.get('sort_by') || 'default';

    return 'custom-availability:' + state.collectionUrl + ':sort=' + sortBy;
  }

  function detachOriginalContent(state) {
    if (state.originalDetached) {
      return;
    }

    while (state.grid.firstChild) {
      state.originalGridHolder.appendChild(state.grid.firstChild);
    }

    while (state.pagination.firstChild) {
      state.originalPaginationHolder.appendChild(state.pagination.firstChild);
    }

    state.originalDetached = true;
  }

  function restoreOriginalContent(state) {
    if (!state.originalDetached) {
      return;
    }

    clearElement(state.grid);
    clearElement(state.pagination);

    while (state.originalGridHolder.firstChild) {
      state.grid.appendChild(state.originalGridHolder.firstChild);
    }

    while (state.originalPaginationHolder.firstChild) {
      state.pagination.appendChild(state.originalPaginationHolder.firstChild);
    }

    state.originalDetached = false;
  }

  function buildUrl(state, mode, page) {
    var url = new URL(window.location.href);
    var normalizedMode = normalizeMode(mode) || 'all';

    if (normalizedMode === 'all') {
      url.searchParams.delete(PARAM_AVAILABILITY);
      url.searchParams.delete(PARAM_PAGE);

      if (state.defaultPage) {
        url.searchParams.set('page', state.defaultPage);
      } else {
        url.searchParams.delete('page');
      }

      return url;
    }

    url.searchParams.set(PARAM_AVAILABILITY, normalizedMode);

    if (page > 1) {
      url.searchParams.set(PARAM_PAGE, String(page));
    } else {
      url.searchParams.delete(PARAM_PAGE);
    }

    url.searchParams.delete('page');

    return url;
  }

  function pushUrl(state, mode, page) {
    window.history.pushState({}, '', buildUrl(state, mode, page).toString());
  }

  function replaceUrl(state, mode, page) {
    window.history.replaceState({}, '', buildUrl(state, mode, page).toString());
  }

  function getModeFromUrl() {
    var currentUrl = new URL(window.location.href);
    return normalizeMode(currentUrl.searchParams.get(PARAM_AVAILABILITY)) || 'all';
  }

  function getPageFromUrl() {
    var currentUrl = new URL(window.location.href);
    return parseInteger(currentUrl.searchParams.get(PARAM_PAGE), 1);
  }

  function normalizeMode(mode) {
    return VALID_MODES.indexOf(mode) > -1 ? mode : null;
  }

  function setCheckmarkState(link, active) {
    link.querySelectorAll('.checkmark, .checkmark__check, .checkmark__indeterminate').forEach(function (node) {
      node.dataset.animationState = active ? 'checked' : 'unchecked';
    });
  }

  function scrollToResults(state) {
    var target = state.summary.hidden ? state.grid : state.summary;

    if (!target) {
      return;
    }

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  function buildPaginationParts(currentPage, totalPages) {
    var pages = [1, totalPages, currentPage - 1, currentPage, currentPage + 1];

    if (currentPage <= 3) {
      pages.push(2, 3);
    }

    if (currentPage >= totalPages - 2) {
      pages.push(totalPages - 2, totalPages - 1);
    }

    var uniquePages = pages.filter(function (page, index, collection) {
      return page >= 1 && page <= totalPages && collection.indexOf(page) === index;
    }).sort(function (left, right) {
      return left - right;
    });
    var parts = [];

    uniquePages.forEach(function (page) {
      var previousPage = parts.length ? parts[parts.length - 1] : null;

      if (previousPage && previousPage !== 'ellipsis' && page - previousPage > 1) {
        parts.push('ellipsis');
      }

      parts.push(page);
    });

    return parts;
  }

  function getImageClass(imageStyle, imageCrop) {
    return 'imagestyle--' + (imageCrop && imageStyle !== 'natural' ? 'cropped-' : '') + imageStyle;
  }

  function getModeLabel(mode) {
    if (mode === 'in-stock') {
      return 'In stock';
    }

    if (mode === 'out-of-stock') {
      return 'Out of stock';
    }

    return 'All';
  }

  function formatPriceRange(state, minPrice, maxPrice) {
    if (!isFiniteNumber(minPrice)) {
      return '';
    }

    if (!isFiniteNumber(maxPrice) || minPrice === maxPrice) {
      return formatMoney(minPrice, state.moneyFormat);
    }

    return formatMoney(minPrice, state.moneyFormat) + ' - ' + formatMoney(maxPrice, state.moneyFormat);
  }

  function formatMoney(cents, format) {
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var placeholderMatch = formatString.match(placeholderRegex);

    if (!placeholderMatch) {
      return formatWithDelimiters(cents, 2);
    }

    var formatType = placeholderMatch[1];
    var value = '';

    if (formatType === 'amount') {
      value = formatWithDelimiters(cents, 2, ',', '.');
    } else if (formatType === 'amount_no_decimals') {
      value = formatWithDelimiters(cents, 0, ',', '.');
    } else if (formatType === 'amount_with_comma_separator') {
      value = formatWithDelimiters(cents, 2, '.', ',');
    } else if (formatType === 'amount_no_decimals_with_comma_separator') {
      value = formatWithDelimiters(cents, 0, '.', ',');
    } else {
      value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return formatString.replace(placeholderRegex, value);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (!isFiniteNumber(number)) {
      return '0';
    }

    var roundedValue = (number / 100).toFixed(precision);
    var parts = roundedValue.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands || ',');
    var cents = parts[1] ? (decimal || '.') + parts[1] : '';

    return dollars + cents;
  }

  function moneyStringToCents(value) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    var parsedValue = Number.parseFloat(value);

    if (!Number.isFinite(parsedValue)) {
      return null;
    }

    return Math.round(parsedValue * 100);
  }

  function withImageWidth(src, width) {
    if (!src) {
      return '';
    }

    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function parseInteger(value, fallbackValue) {
    var parsedValue = Number.parseInt(value, 10);
    return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function clearElement(element) {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  function formatNumber(value) {
    return new Intl.NumberFormat().format(value);
  }

  function isFiniteNumber(value) {
    return Number.isFinite(value);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
